import { useCallback, useEffect, useState } from "react";

import { COOKIE_CONSENT_EVENT_NAME, hasCookieConsent, setCookieConsentAccepted } from "@/lib/consent";

export function useCookieConsent() {
  const [accepted, setAccepted] = useState(() => hasCookieConsent());

  useEffect(() => {
    function syncConsent() {
      setAccepted(hasCookieConsent());
    }

    window.addEventListener("storage", syncConsent);
    window.addEventListener(COOKIE_CONSENT_EVENT_NAME, syncConsent);
    return () => {
      window.removeEventListener("storage", syncConsent);
      window.removeEventListener(COOKIE_CONSENT_EVENT_NAME, syncConsent);
    };
  }, []);

  const accept = useCallback(() => {
    setCookieConsentAccepted();
    setAccepted(true);
  }, []);

  return {
    accepted,
    requiresConsent: !accepted,
    accept
  };
}
